module.exports = __webpack_public_path__ + "static/media/Metronome1.9f98ab86.mp3";